<template>
    <form @submit.prevent="$emit('onEvent', reason)">
        <app-model :class="{ 'show': show }" size="model-sm" :style="'z-index: 1100;'">
            <template v-slot:header class="modal-header d-flex align-items-center">
                <h4 class="card-title mb-0">Rechazar evento</h4>
                <button type="button" @click="onClose()" class="btn-close"></button>
            </template>
            <template v-slot:body class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-3">
                            <p>¿Realmente desea rechazar este evento?<br> debes agregar tu razón de rechazo.</p>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control" name="reason" rows="5" v-model="reason"></textarea>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer class="modal-footer">
                <button type="submit" class="btn btn-danger text-white rounded-pill px-4">
                    <span v-if="submit" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span :class="{ 'visually-hidden': submit }">
                        <i class="ti ti-device-floppy me-1 fs-4"></i> Rechazar
                    </span>
                </button>
                <button type="button" @click="onClose()"
                    class="btn btn-dark rounded-pill px-4 ms-2 text-white">Cancelar</button>
            </template>
        </app-model>
    </form>
</template>
<script>
export default {
  props: {
    id: {
      type: String | Number,
      default: null
    },
    submit: {
      type: Boolean,
      default: false
    },
    onEvent: {
      type: Function,
      default: () => { console.log('aca') }
    }
  },
  data () {
    return {
      show: false,
      reason: null
    }
  },
  created () {
    setInterval(() => {
      if (this.id) {
        this.show = true
      }
    }, 100)
  },
  methods: {
    onClose: function () {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/calendar/events/Reject.vue